
import _ from 'lodash';

class Hl7utils {
     static sections = ["ABS|", "ACC|", "ADD|", "AFF|", "AIG|", "AIL|", "AIP|", "AIS|", "AL1|", "APR|", "ARQ|", "AUT|", "BHS|", "BLC|", "BLG|", "BPO|", "BPX|", "BTS|", "BTX|", "CDM|", "CER|", "CM0|", "CM1|", "CM2|", "CNS|", "CON_|", "CSP|", "CSR|", "CSS|", "CTD|", "CTI|", "DB1|", "DG1|", "DRG|", "DSC|", "DSP|", "ECD|", "ECR|", "EDU|", "EQL|", "EQP|", "EQU|", "ERQ|", "ERR|", "EVN|", "FAC|", "FHS|", "FT1|", "FTS|", "GOL|", "GP1|", "GP2|", "GT1|", "Hxx|", "IAM|", "IIM|", "IN1|", "IN2|", "IN3|", "INV|", "IPC|", "ISD|", "LAN|", "LCC|", "LCH|", "LDP|", "LOC|", "LRL|", "MFA|", "MFE|", "MFI|", "MRG|", "MSA|", "NCK|", "NDS|", "NK1|", "NPU|", "NSC|", "NST|", "NTE|", "OBR|", "OBX|", "ODS|", "ODT|", "OM1|", "OM2|", "OM3|", "OM4|", "OM5|", "OM6|", "OM7|", "ORC|", "ORG|", "OVR|", "PCR|", "PD1|", "PDA|", "PDC|", "PEO|", "PES|", "PID|", "PR1|", "PRA|", "PRB|", "PRC|", "PRD|", "PSH|", "PTH|", "PV1|", "PV2|", "QAK|", "QID|", "QPD|", "QRD|", "QRF|", "QRI|", "RCP|", "RDF|", "RDT|", "RF1|", "RGS|", "RMI|", "ROL|", "RQ1|", "RQD|", "RXA|", "RXC|", "RXD|", "RXE|", "RXG|", "RXO|", "RXR|", "SAC|", "SCH|", "SFT|", "SID|", "SPM|", "SPR|", "STF|", "TCC|", "TCD|", "TQ1|", "TQ2|", "TXA|", "UB1|", "UB2|", "URD|", "URS|", "VAR|", "VTQ|", "ZL7|", "ZU1|", "ZU2|", "ZU3|", "ZU4|", "Z01|", "ZBX|", "ZPI|", "ZVI|"];
     static  parsed = [];
     static currentContent = "";
     static forClip = true;
     static parseMessages(message) {
        this.currentContent = message.replace("MSH|^~\\&|", "MSH|^~\\&|");
        this.parsed = [];
        while (this.parseNext()) {

        }
        return this.parsed;
    };

    static parseHl7ToJson(str) {
        var segments = str.split('\n');
        return _.map(segments, function (segment) {
            var fields = segment.split('|');
            return _.map(fields, function (field) {
                return _.includes(field, '^') ? field.split('^') : field;
            });
        });
    }
     static parseNext () {
        let haveQuotation = false;
        let doubleSlash = false;
        let index1 = this.currentContent.indexOf("MSH|^~\\\\\\\\&|");
        if (index1 > 0) {
            this.currentContent = this.currentContent.replace("\\\\", "\\");
        }
        index1 = this.currentContent.indexOf("MSH|^~\\\\&|");
        let index2 = this.currentContent.indexOf("MSH|^~\\&|");
        if (index1 > -1 && (index2 < 0 || (index2 > 0 && index1 < index2))) {
            doubleSlash = true;
            haveQuotation = false;
        }
        if (index2 > -1 && (index1 < 0 || (index1 > 0 && index1 > index2))) {
            index1 = index2;
            doubleSlash = false;
            haveQuotation = false;
        }
        index2 = this.currentContent.indexOf("\"MSH|^~\\&|");
        if (index2 > -1 && (index1 < 0 || (index1 > 0 && index1 > index2))) {
            index1 = index2;
            doubleSlash = false;
            haveQuotation = true;
        }
        index2 = this.currentContent.indexOf("\"MSH|^~\\\\&|");
        if (index2 > -1 && (index1 < 0 || (index1 > 0 && index1 > index2))) {
            index1 = index2;
            doubleSlash = true;
            haveQuotation = true;
        }
        if (index1 >= 0) {
            return this.parseFrom(index1, haveQuotation, doubleSlash);
        }
        return false;
    }

     static parseFrom (index, haveQuotation, doubleSlash) {
        let lineSeparator = "";
        let entersToLook = doubleSlash ? "\\\\r" : "\\r";
        this.currentContent = this.currentContent.substring(index + (haveQuotation ? 1 : 0));
        let toffset = 1;
        while (toffset < this.currentContent.length) {
            if (this.currentContent.startsWith("\\\\r", toffset)) {
                lineSeparator = "\\\\r";
                break;
            }
            if (this.currentContent.startsWith("\\r", toffset)) {
                lineSeparator = "\\r";
                break;
            }
            if (this.currentContent.startsWith("\r", toffset)) {
                lineSeparator = "\r";
                break;
            }
            if (this.currentContent.startsWith("\n", toffset)) {
                lineSeparator = "\n";
                break;
            }
            if (this.currentContent.startsWith(",", toffset)) {
                if (this.isSectionStart(toffset + 1)) {
                    lineSeparator = ",";
                    break;
                }
            }

            toffset++;
        }
        if (!lineSeparator || lineSeparator.length === 0) {
            return false;
        }
        let hl7lines = [];
        let endline = this.currentContent.indexOf(lineSeparator);
        let trimPotentialQuote = false;
        while (endline > 0) {
            let line = this.currentContent.substring(0, endline);
            if (doubleSlash) {
                line = line.replace("\\\\", "\\");
            }
            if (trimPotentialQuote && haveQuotation && line.endsWith("\"")) {
                line = line.substring(0, line.length - 1);
            }
            hl7lines.push(line.trim());
            this.currentContent = this.currentContent.substring(endline).trim();
            if (this.currentContent.startsWith(lineSeparator)) {
                this.currentContent = this.currentContent.substring(lineSeparator.length);
            }
            if (this.isSectionStart(0)) {
                endline = this.currentContent.indexOf(lineSeparator);
                let endline1 = this.currentContent.indexOf("\r");
                if (endline1 > 0 && (endline < 0 || (endline > -1 && endline1 < endline))) {
                    endline = endline1;
                }
                endline1 = this.currentContent.indexOf("\n");
                if (endline1 > 0 && (endline < 0 || (endline > -1 && endline1 < endline))) {
                    endline = endline1;
                }
                if (endline < 0) {
                    trimPotentialQuote = true;
                    endline = this.currentContent.length;
                }
            } else {
                endline = -1;
            }
        }
        this.storeMessage(hl7lines);
        return true;
    };

     static isSectionStart(offset) {
        for (let sStart of this.sections) {
            if (this.currentContent.startsWith(sStart, offset)) {
                return true;
            }
        }
        return false;
    };

     static storeMessage(hl7lines) {
        let sbMess = "";
        if (hl7lines != null && hl7lines.length > 0) {
            if (hl7lines[0].indexOf("|ACK^") == -1) {
                for (let line of hl7lines) {
                    let separator = "";
                    if (sbMess.length > 0) {
                        if (this.forClip) {
                            separator = "\r\n";
                        } else {
                            separator = "\r";
                        }
                    }
                    sbMess = `${sbMess}${separator}${line}`;
                }
                this.parsed.push(sbMess);
            }
        }
    }

}

export default Hl7utils;